<!-- @format -->

@if (product) {
  <sis-description-list [columnCount]="1">
    <ng-template #listItem>
      <dt>{{ "OPEN_UNIVERSITY.STUDY_OFFERING.CREDITS_LABEL" | translate }}</dt>
      <dd>{{ product.credits | decimalNumber }} {{ "CREDITS" | translate }}</dd>
    </ng-template>
    <ng-template #listItem>
      <dt>{{ "OPEN_UNIVERSITY.STUDY_OFFERING.ASSESSMENT_ITEMS" | translate }}</dt>
      @for (assessmentItem of assessmentItems$ | async; track entityId($index, assessmentItem)) {
        <dd>
          {{ assessmentItem.name | localizedString }}
        </dd>
      }
    </ng-template>
    <ng-template #listItem>
      <dt>{{ "OPEN_UNIVERSITY.STUDY_OFFERING.PRICE" | translate }}</dt>
      <dd>{{ product.price | money }}</dd>
    </ng-template>
    @if (isOnSale) {
      <ng-template #listItem>
        <dt>{{ "OPEN_UNIVERSITY.STUDY_OFFERING.SALES_PERIOD_ENDS" | translate }}</dt>
        <dd>{{ product.salesPeriod.endDateTime | localDateTimeFormat }}</dd>
      </ng-template>
    }
    @if (isFutureProduct) {
      <ng-template #listItem>
        <dt>{{ "OPEN_UNIVERSITY.STUDY_OFFERING.SALES_PERIOD_STARTS" | translate }}</dt>
        <dd>{{ product.salesPeriod.startDateTime | localDateTimeFormat }}</dd>
      </ng-template>
    }
  </sis-description-list>
}
